module.exports = __webpack_public_path__ + "img/ig-logo.63175b2e.png";